// Translations for Profile Promotion (Flame 🔥) and Story-sharing modals.
// 13 languages: en, es, fr, ar, pt, de, ru, zh, ja, hi, nl, sw, ht

import { useLanguage } from '../context/LanguageContext';

const D = {
  // ---------- English (fallback) ----------
  en: {
    promote: {
      buttonTitle: 'Promote my profile',
      modalTitle: 'Promote my profile',
      modalSubtitle: 'Boost your profile in the voice feed for 7 days',
      price: '€10',
      duration: '7 days',
      howItWorksTitle: 'How it works',
      howItWorks1: 'Your profile (photo, name, description, audio intro) is injected randomly in the voice feed.',
      howItWorks2: 'Broadcast for 7 days to random Destine users.',
      howItWorks3: 'Track your new followers from Settings › Promote my profile.',
      payBtn: 'Pay €10 and start',
      paying: 'Redirecting to Stripe…',
      alreadyActive: 'A promotion is already active — wait until it ends before paying again.',
      daysLeft: '{n} day(s) left',
      followersGained: '+{n} new followers since promotion',
      settingsSectionTitle: 'Promote my profile',
      settingsSectionDesc: 'Boost your profile visibility in the voice feed for 7 days.',
      activePromoLabel: 'Active promotion',
      noActivePromo: 'No active promotion',
      startPromo: 'Start a promotion (€10 / 7 days)',
      history: 'History',
      close: 'Close', cancel: 'Cancel',
      promoLabel: 'Promoted profile',
      followBtn: 'Follow', followingBtn: 'Following',
      posts: 'Posts', likes: 'Likes', views: 'Views', plays: 'Plays', followers: 'Followers', following: 'Following',
      successToast: 'Promotion active until {date} 🎉',
      confirmPay: 'Pay €10 for 7 days of profile promotion?',
    },
    story: {
      shareGimToStory: 'Share to story', sharePodcastToStory: 'Share podcast to story',
      shared: 'Shared to story!', shareError: 'Error sharing to story',
      viewGimToli: 'Play in feed', viewPodcast: 'Play in feed',
      gimShared: 'Gim Toli', podcastShared: 'Podcast',
    },
    feed: {
      share: 'Share', shareToStory: 'Share to story', shareWithSponsor: 'Share with sponsor', cancel: 'Cancel',
      save: 'Save', unsave: 'Remove from saved', report: 'Report', moreOptions: 'More options',
      translateVoice: 'Translate this voice', translating: 'Translating…',
      playingNow: 'Now playing…', replyWithGim: 'Reply with a Gim Toli',
    },
    categories: { catCinema: 'Cinema', catSeries: 'Series', catMaking: 'Making-of', catTech: 'Tech', catMusic: 'Film music', catInterviews: 'Interviews', catReviews: 'Reviews' },
    comments: { title: 'Comments', addPh: 'Add a comment…', beFirst: 'No comments — be the first!' },
  },
  // ---------- French ----------
  fr: {
    promote: {
      buttonTitle: 'Promouvoir mon profil',
      modalTitle: 'Promouvoir mon profil',
      modalSubtitle: 'Booste la visibilité de ton profil dans le feed vocaux pendant 7 jours',
      price: '10€', duration: '7 jours',
      howItWorksTitle: 'Comment ça marche',
      howItWorks1: 'Ton profil (photo, nom, description, audio de présentation) est diffusé aléatoirement dans le feed vocaux.',
      howItWorks2: 'Diffusion pendant 7 jours à des utilisateurs Destine.',
      howItWorks3: 'Suis les nouveaux abonnés depuis Paramètres › Promouvoir mon profil.',
      payBtn: 'Payer 10€ et démarrer', paying: 'Redirection vers Stripe…',
      alreadyActive: 'Une promotion est déjà active — attends la fin avant de repayer.',
      daysLeft: '{n} jour(s) restant(s)',
      followersGained: '+{n} nouveaux abonnés depuis la promotion',
      settingsSectionTitle: 'Promouvoir mon profil',
      settingsSectionDesc: 'Booste la visibilité de ton profil dans le feed vocaux pendant 7 jours.',
      activePromoLabel: 'Promotion active',
      noActivePromo: 'Aucune promotion active',
      startPromo: 'Démarrer une promotion (10€ / 7 jours)',
      history: 'Historique', close: 'Fermer', cancel: 'Annuler',
      promoLabel: 'Profil promu',
      followBtn: "S'abonner", followingBtn: 'Abonné',
      posts: 'Publications', likes: 'Likes', views: 'Vues', plays: 'Lectures', followers: 'Abonnés', following: 'Abonnements',
      successToast: "Promotion active jusqu'au {date} 🎉",
      confirmPay: 'Payer 10€ pour 7 jours de promotion du profil ?',
    },
    story: {
      shareGimToStory: 'Partager en story', sharePodcastToStory: 'Partager le podcast en story',
      shared: 'Partagé en story !', shareError: 'Erreur lors du partage en story',
      viewGimToli: 'Voir dans le feed', viewPodcast: 'Voir dans le feed',
      gimShared: 'Gim Toli', podcastShared: 'Podcast',
    },
    feed: {
      share: 'Partager', shareToStory: 'Partager en story', shareWithSponsor: 'Partager avec sponsor', cancel: 'Annuler',
      save: 'Enregistrer', unsave: 'Retirer des enregistrements', report: 'Signaler', moreOptions: "Plus d'options",
      translateVoice: 'Traduire ce vocal', translating: 'Traduction…',
      playingNow: 'En cours de lecture…', replyWithGim: 'Répondre avec un Gim Toli',
    },
    categories: { catCinema: 'Cinéma', catSeries: 'Séries', catMaking: 'Making-of', catTech: 'Tech', catMusic: 'Musiques de films', catInterviews: 'Interviews', catReviews: 'Critiques' },
    comments: { title: 'Commentaires', addPh: 'Ajouter un commentaire…', beFirst: 'Aucun commentaire — soyez le premier !' },
  },
  // ---------- Spanish ----------
  es: {
    promote: {
      buttonTitle: 'Promocionar mi perfil', modalTitle: 'Promocionar mi perfil',
      modalSubtitle: 'Impulsa tu perfil en el feed de voces durante 7 días',
      price: '10€', duration: '7 días',
      howItWorksTitle: 'Cómo funciona',
      howItWorks1: 'Tu perfil (foto, nombre, descripción, audio) aparece aleatoriamente en el feed de voces.',
      howItWorks2: 'Difusión durante 7 días a usuarios aleatorios.',
      howItWorks3: 'Sigue tus nuevos seguidores desde Ajustes › Promocionar mi perfil.',
      payBtn: 'Pagar 10€ y comenzar', paying: 'Redirigiendo a Stripe…',
      alreadyActive: 'Ya hay una promoción activa — espera a que termine.',
      daysLeft: '{n} día(s) restante(s)',
      followersGained: '+{n} nuevos seguidores desde la promoción',
      settingsSectionTitle: 'Promocionar mi perfil',
      settingsSectionDesc: 'Impulsa la visibilidad de tu perfil en el feed de voces por 7 días.',
      activePromoLabel: 'Promoción activa', noActivePromo: 'Sin promoción activa',
      startPromo: 'Iniciar promoción (10€ / 7 días)',
      history: 'Historial', close: 'Cerrar', cancel: 'Cancelar',
      promoLabel: 'Perfil promocionado',
      followBtn: 'Seguir', followingBtn: 'Siguiendo',
      posts: 'Publicaciones', likes: 'Me gusta', views: 'Vistas', plays: 'Reproducciones', followers: 'Seguidores', following: 'Siguiendo',
      successToast: '¡Promoción activa hasta {date}! 🎉',
      confirmPay: '¿Pagar 10€ por 7 días de promoción?',
    },
    story: {
      shareGimToStory: 'Compartir en historia', sharePodcastToStory: 'Compartir podcast en historia',
      shared: '¡Compartido en historia!', shareError: 'Error al compartir',
      viewGimToli: 'Ver en el feed', viewPodcast: 'Ver en el feed',
      gimShared: 'Gim Toli', podcastShared: 'Podcast',
    },
    feed: {
      share: 'Compartir', shareToStory: 'Compartir en historia', shareWithSponsor: 'Compartir con patrocinador', cancel: 'Cancelar',
      save: 'Guardar', unsave: 'Quitar de guardados', report: 'Reportar', moreOptions: 'Más opciones',
      translateVoice: 'Traducir este audio', translating: 'Traduciendo…',
      playingNow: 'Reproduciendo…', replyWithGim: 'Responder con un Gim Toli',
    },
    categories: { catCinema: 'Cine', catSeries: 'Series', catMaking: 'Cómo se hizo', catTech: 'Tech', catMusic: 'Música de películas', catInterviews: 'Entrevistas', catReviews: 'Reseñas' },
    comments: { title: 'Comentarios', addPh: 'Agregar un comentario…', beFirst: 'Sin comentarios — sé el primero!' },
  },
  // ---------- Arabic ----------
  ar: {
    promote: {
      buttonTitle: 'روّج لملفي', modalTitle: 'روّج لملفي',
      modalSubtitle: 'عزّز ملفك في خلاصة الصوت لمدة 7 أيام',
      price: '10€', duration: '7 أيام',
      howItWorksTitle: 'كيف يعمل',
      howItWorks1: 'يظهر ملفك (صورة، اسم، وصف، صوت) عشوائياً في خلاصة الصوت.',
      howItWorks2: 'بث لمدة 7 أيام لمستخدمين عشوائيين.',
      howItWorks3: 'تابع المتابعين الجدد من الإعدادات › روّج لملفي.',
      payBtn: 'ادفع 10€ وابدأ', paying: 'إعادة التوجيه إلى Stripe…',
      alreadyActive: 'يوجد ترويج نشط — انتظر حتى ينتهي.',
      daysLeft: '{n} يوم/أيام متبقية',
      followersGained: '+{n} متابعون جدد منذ الترويج',
      settingsSectionTitle: 'روّج لملفي',
      settingsSectionDesc: 'عزّز رؤية ملفك في خلاصة الصوت لمدة 7 أيام.',
      activePromoLabel: 'ترويج نشط', noActivePromo: 'لا يوجد ترويج نشط',
      startPromo: 'ابدأ ترويجاً (10€ / 7 أيام)',
      history: 'السجل', close: 'إغلاق', cancel: 'إلغاء',
      promoLabel: 'ملف مروَّج له',
      followBtn: 'متابعة', followingBtn: 'متابع',
      posts: 'المنشورات', likes: 'إعجابات', views: 'مشاهدات', plays: 'تشغيل', followers: 'متابعون', following: 'يتابع',
      successToast: 'الترويج نشط حتى {date} 🎉',
      confirmPay: 'دفع 10€ لمدة 7 أيام من الترويج؟',
    },
    story: {
      shareGimToStory: 'مشاركة كقصة', sharePodcastToStory: 'مشاركة البودكاست كقصة',
      shared: 'تمّت المشاركة!', shareError: 'خطأ في المشاركة',
      viewGimToli: 'اذهب إلى الخلاصة', viewPodcast: 'اذهب إلى الخلاصة',
      gimShared: 'Gim Toli', podcastShared: 'بودكاست',
    },
    feed: {
      share: 'مشاركة', shareToStory: 'مشاركة كقصة', shareWithSponsor: 'مشاركة مع راعٍ', cancel: 'إلغاء',
      save: 'حفظ', unsave: 'إزالة من المحفوظات', report: 'إبلاغ', moreOptions: 'خيارات أكثر',
      translateVoice: 'ترجمة هذا الصوت', translating: 'جارٍ الترجمة…',
      playingNow: 'يتم التشغيل الآن…', replyWithGim: 'الردّ بـ Gim Toli',
    },
    categories: { catCinema: 'سينما', catSeries: 'مسلسلات', catMaking: 'كواليس', catTech: 'تقنية', catMusic: 'موسيقى الأفلام', catInterviews: 'مقابلات', catReviews: 'نقد' },
    comments: { title: 'تعليقات', addPh: 'أضف تعليقًا…', beFirst: 'لا توجد تعليقات — كن الأول!' },
  },
  // ---------- Portuguese ----------
  pt: {
    promote: {
      buttonTitle: 'Promover meu perfil', modalTitle: 'Promover meu perfil',
      modalSubtitle: 'Impulsione seu perfil no feed de vozes por 7 dias',
      price: '10€', duration: '7 dias',
      howItWorksTitle: 'Como funciona',
      howItWorks1: 'Seu perfil (foto, nome, descrição, áudio) aparece aleatoriamente no feed.',
      howItWorks2: 'Difusão por 7 dias para usuários aleatórios.',
      howItWorks3: 'Acompanhe seus novos seguidores em Configurações › Promover meu perfil.',
      payBtn: 'Pagar 10€ e iniciar', paying: 'Redirecionando ao Stripe…',
      alreadyActive: 'Já existe uma promoção ativa — aguarde o fim.',
      daysLeft: '{n} dia(s) restantes',
      followersGained: '+{n} novos seguidores desde a promoção',
      settingsSectionTitle: 'Promover meu perfil',
      settingsSectionDesc: 'Aumente a visibilidade do seu perfil no feed de vozes por 7 dias.',
      activePromoLabel: 'Promoção ativa', noActivePromo: 'Sem promoção ativa',
      startPromo: 'Iniciar promoção (10€ / 7 dias)',
      history: 'Histórico', close: 'Fechar', cancel: 'Cancelar',
      promoLabel: 'Perfil promovido',
      followBtn: 'Seguir', followingBtn: 'Seguindo',
      posts: 'Publicações', likes: 'Curtidas', views: 'Visualizações', plays: 'Reproduções', followers: 'Seguidores', following: 'Seguindo',
      successToast: 'Promoção ativa até {date} 🎉',
      confirmPay: 'Pagar 10€ por 7 dias de promoção?',
    },
    story: {
      shareGimToStory: 'Compartilhar no story', sharePodcastToStory: 'Compartilhar podcast no story',
      shared: 'Compartilhado no story!', shareError: 'Erro ao compartilhar',
      viewGimToli: 'Ver no feed', viewPodcast: 'Ver no feed',
      gimShared: 'Gim Toli', podcastShared: 'Podcast',
    },
    feed: {
      share: 'Compartilhar', shareToStory: 'Compartilhar no story', shareWithSponsor: 'Compartilhar com patrocinador', cancel: 'Cancelar',
      save: 'Salvar', unsave: 'Remover dos salvos', report: 'Denunciar', moreOptions: 'Mais opções',
      translateVoice: 'Traduzir este áudio', translating: 'Traduzindo…',
      playingNow: 'Reproduzindo…', replyWithGim: 'Responder com Gim Toli',
    },
    categories: { catCinema: 'Cinema', catSeries: 'Séries', catMaking: 'Making-of', catTech: 'Tech', catMusic: 'Música de filmes', catInterviews: 'Entrevistas', catReviews: 'Críticas' },
    comments: { title: 'Comentários', addPh: 'Adicionar um comentário…', beFirst: 'Sem comentários — seja o primeiro!' },
  },
  // ---------- German ----------
  de: {
    promote: {
      buttonTitle: 'Profil promoten', modalTitle: 'Profil promoten',
      modalSubtitle: 'Boost dein Profil 7 Tage lang im Voice-Feed',
      price: '10€', duration: '7 Tage',
      howItWorksTitle: 'So funktioniert es',
      howItWorks1: 'Dein Profil (Foto, Name, Beschreibung, Audio) erscheint zufällig im Voice-Feed.',
      howItWorks2: 'Verbreitung über 7 Tage an zufällige Nutzer.',
      howItWorks3: 'Verfolge neue Follower unter Einstellungen › Profil promoten.',
      payBtn: '10€ zahlen und starten', paying: 'Weiterleitung zu Stripe…',
      alreadyActive: 'Aktive Promotion — bitte warten.',
      daysLeft: 'Noch {n} Tag(e)',
      followersGained: '+{n} neue Follower seit der Promotion',
      settingsSectionTitle: 'Profil promoten',
      settingsSectionDesc: 'Erhöhe deine Sichtbarkeit im Voice-Feed 7 Tage lang.',
      activePromoLabel: 'Aktive Promotion', noActivePromo: 'Keine aktive Promotion',
      startPromo: 'Promotion starten (10€ / 7 Tage)',
      history: 'Verlauf', close: 'Schließen', cancel: 'Abbrechen',
      promoLabel: 'Beworbenes Profil',
      followBtn: 'Folgen', followingBtn: 'Folge ich',
      posts: 'Beiträge', likes: 'Likes', views: 'Aufrufe', plays: 'Abspielungen', followers: 'Follower', following: 'Folgt',
      successToast: 'Promotion aktiv bis {date} 🎉',
      confirmPay: '10€ für 7 Tage Promotion zahlen?',
    },
    story: {
      shareGimToStory: 'In Story teilen', sharePodcastToStory: 'Podcast in Story teilen',
      shared: 'In Story geteilt!', shareError: 'Fehler beim Teilen',
      viewGimToli: 'Im Feed öffnen', viewPodcast: 'Im Feed öffnen',
      gimShared: 'Gim Toli', podcastShared: 'Podcast',
    },
    feed: {
      share: 'Teilen', shareToStory: 'In Story teilen', shareWithSponsor: 'Mit Sponsor teilen', cancel: 'Abbrechen',
      save: 'Speichern', unsave: 'Aus Gespeichertem entfernen', report: 'Melden', moreOptions: 'Weitere Optionen',
      translateVoice: 'Diese Sprachnachricht übersetzen', translating: 'Übersetzung…',
      playingNow: 'Wird abgespielt…', replyWithGim: 'Mit Gim Toli antworten',
    },
    categories: { catCinema: 'Kino', catSeries: 'Serien', catMaking: 'Making-of', catTech: 'Tech', catMusic: 'Filmmusik', catInterviews: 'Interviews', catReviews: 'Kritiken' },
    comments: { title: 'Kommentare', addPh: 'Kommentar hinzufügen…', beFirst: 'Noch keine Kommentare — sei der Erste!' },
  },
  // ---------- Russian ----------
  ru: {
    promote: {
      buttonTitle: 'Продвигать профиль', modalTitle: 'Продвигать профиль',
      modalSubtitle: 'Повысьте видимость профиля в голосовой ленте на 7 дней',
      price: '10€', duration: '7 дней',
      howItWorksTitle: 'Как это работает',
      howItWorks1: 'Ваш профиль (фото, имя, описание, аудио) случайно появляется в ленте.',
      howItWorks2: 'Трансляция 7 дней случайным пользователям.',
      howItWorks3: 'Отслеживайте новых подписчиков в Настройки › Продвигать профиль.',
      payBtn: 'Оплатить 10€ и запустить', paying: 'Переход в Stripe…',
      alreadyActive: 'Продвижение уже активно — дождитесь окончания.',
      daysLeft: 'Осталось {n} дн.',
      followersGained: '+{n} новых подписчиков',
      settingsSectionTitle: 'Продвигать профиль',
      settingsSectionDesc: 'Повысьте видимость профиля в голосовой ленте на 7 дней.',
      activePromoLabel: 'Активное продвижение', noActivePromo: 'Нет активного продвижения',
      startPromo: 'Начать продвижение (10€ / 7 дней)',
      history: 'История', close: 'Закрыть', cancel: 'Отмена',
      promoLabel: 'Продвигаемый профиль',
      followBtn: 'Подписаться', followingBtn: 'Вы подписаны',
      posts: 'Публикации', likes: 'Лайки', views: 'Просмотры', plays: 'Воспроизведения', followers: 'Подписчики', following: 'Подписки',
      successToast: 'Продвижение активно до {date} 🎉',
      confirmPay: 'Оплатить 10€ за 7 дней?',
    },
    story: {
      shareGimToStory: 'Поделиться в истории', sharePodcastToStory: 'Поделиться подкастом в истории',
      shared: 'Поделились в истории!', shareError: 'Ошибка публикации',
      viewGimToli: 'Открыть в ленте', viewPodcast: 'Открыть в ленте',
      gimShared: 'Gim Toli', podcastShared: 'Подкаст',
    },
    feed: {
      share: 'Поделиться', shareToStory: 'Поделиться в истории', shareWithSponsor: 'Поделиться со спонсором', cancel: 'Отмена',
      save: 'Сохранить', unsave: 'Убрать из сохранённого', report: 'Пожаловаться', moreOptions: 'Ещё',
      translateVoice: 'Перевести это аудио', translating: 'Перевод…',
      playingNow: 'Сейчас играет…', replyWithGim: 'Ответить голосом',
    },
    categories: { catCinema: 'Кино', catSeries: 'Сериалы', catMaking: 'Как снимали', catTech: 'Технологии', catMusic: 'Музыка из фильмов', catInterviews: 'Интервью', catReviews: 'Рецензии' },
    comments: { title: 'Комментарии', addPh: 'Добавить комментарий…', beFirst: 'Комментариев нет — оставьте первый!' },
  },
  // ---------- Chinese ----------
  zh: {
    promote: {
      buttonTitle: '推广我的资料', modalTitle: '推广我的资料',
      modalSubtitle: '在语音流中推广您的资料 7 天',
      price: '€10', duration: '7 天',
      howItWorksTitle: '工作原理',
      howItWorks1: '您的资料（照片、姓名、简介、音频）随机出现在语音流中。',
      howItWorks2: '为期 7 天推送给随机用户。',
      howItWorks3: '在 设置 › 推广我的资料 中查看新粉丝。',
      payBtn: '支付 €10 并开始', paying: '正在跳转到 Stripe…',
      alreadyActive: '已有推广，请等待结束。',
      daysLeft: '还剩 {n} 天',
      followersGained: '推广后 +{n} 新粉丝',
      settingsSectionTitle: '推广我的资料',
      settingsSectionDesc: '在语音流中提升资料曝光 7 天。',
      activePromoLabel: '推广进行中', noActivePromo: '暂无推广',
      startPromo: '开始推广（€10 / 7 天）',
      history: '历史', close: '关闭', cancel: '取消',
      promoLabel: '推广资料',
      followBtn: '关注', followingBtn: '已关注',
      posts: '帖子', likes: '点赞', views: '观看', plays: '播放', followers: '粉丝', following: '关注',
      successToast: '推广有效至 {date} 🎉',
      confirmPay: '支付 €10 进行 7 天推广？',
    },
    story: {
      shareGimToStory: '分享到故事', sharePodcastToStory: '分享播客到故事',
      shared: '已分享到故事！', shareError: '分享失败',
      viewGimToli: '在信息流中查看', viewPodcast: '在信息流中查看',
      gimShared: 'Gim Toli', podcastShared: '播客',
    },
    feed: {
      share: '分享', shareToStory: '分享到故事', shareWithSponsor: '与赞助商分享', cancel: '取消',
      save: '保存', unsave: '取消保存', report: '举报', moreOptions: '更多选项',
      translateVoice: '翻译此语音', translating: '翻译中…',
      playingNow: '正在播放…', replyWithGim: '用 Gim Toli 回复',
    },
    categories: { catCinema: '电影', catSeries: '剧集', catMaking: '幕后花絮', catTech: '科技', catMusic: '电影配乐', catInterviews: '访谈', catReviews: '评论' },
    comments: { title: '评论', addPh: '添加评论…', beFirst: '暂无评论 — 抢沙发！' },
  },
  // ---------- Japanese ----------
  ja: {
    promote: {
      buttonTitle: 'プロフィールを宣伝', modalTitle: 'プロフィールを宣伝',
      modalSubtitle: '音声フィードで 7 日間プロフィールをブースト',
      price: '10€', duration: '7 日',
      howItWorksTitle: '仕組み',
      howItWorks1: 'あなたのプロフィール（写真・名前・自己紹介・音声）が音声フィードにランダムに表示されます。',
      howItWorks2: '7 日間ランダムなユーザーに配信。',
      howItWorks3: '設定 › プロフィール宣伝 で新規フォロワーを追跡。',
      payBtn: '10€ を支払って開始', paying: 'Stripe へリダイレクト中…',
      alreadyActive: '宣伝が実施中です。終了までお待ちください。',
      daysLeft: '残り {n} 日',
      followersGained: '宣伝後 +{n} 人の新規フォロワー',
      settingsSectionTitle: 'プロフィールを宣伝',
      settingsSectionDesc: '音声フィードでの露出を 7 日間強化します。',
      activePromoLabel: '宣伝中', noActivePromo: '宣伝なし',
      startPromo: '宣伝を開始（10€ / 7 日）',
      history: '履歴', close: '閉じる', cancel: 'キャンセル',
      promoLabel: 'プロモ プロフィール',
      followBtn: 'フォロー', followingBtn: 'フォロー中',
      posts: '投稿', likes: 'いいね', views: '再生数', plays: '再生', followers: 'フォロワー', following: 'フォロー中',
      successToast: '宣伝有効: {date} まで 🎉',
      confirmPay: '10€ で 7 日間の宣伝を購入しますか？',
    },
    story: {
      shareGimToStory: 'ストーリーで共有', sharePodcastToStory: 'ポッドキャストをストーリーで共有',
      shared: 'ストーリーで共有しました！', shareError: '共有エラー',
      viewGimToli: 'フィードで見る', viewPodcast: 'フィードで見る',
      gimShared: 'Gim Toli', podcastShared: 'ポッドキャスト',
    },
    feed: {
      share: '共有', shareToStory: 'ストーリーで共有', shareWithSponsor: 'スポンサーと共有', cancel: 'キャンセル',
      save: '保存', unsave: '保存を解除', report: '報告', moreOptions: 'その他のオプション',
      translateVoice: 'この音声を翻訳', translating: '翻訳中…',
      playingNow: '再生中…', replyWithGim: 'Gim Toli で返信',
    },
    categories: { catCinema: '映画', catSeries: 'シリーズ', catMaking: 'メイキング', catTech: 'テック', catMusic: '映画音楽', catInterviews: 'インタビュー', catReviews: 'レビュー' },
    comments: { title: 'コメント', addPh: 'コメントを追加…', beFirst: 'コメントなし — 最初に投稿しよう！' },
  },
  // ---------- Hindi ----------
  hi: {
    promote: {
      buttonTitle: 'मेरा प्रोफ़ाइल प्रचारित करें', modalTitle: 'मेरा प्रोफ़ाइल प्रचारित करें',
      modalSubtitle: '7 दिनों तक वॉइस फ़ीड में अपनी प्रोफ़ाइल बूस्ट करें',
      price: '€10', duration: '7 दिन',
      howItWorksTitle: 'यह कैसे काम करता है',
      howItWorks1: 'आपकी प्रोफ़ाइल (फ़ोटो, नाम, विवरण, ऑडियो) वॉइस फ़ीड में यादृच्छिक रूप से दिखती है।',
      howItWorks2: '7 दिनों तक यादृच्छिक उपयोगकर्ताओं को प्रसारण।',
      howItWorks3: 'सेटिंग्स › मेरा प्रोफ़ाइल प्रचारित करें में नए फॉलोअर देखें।',
      payBtn: '€10 चुकाएँ और शुरू करें', paying: 'Stripe पर रीडायरेक्ट…',
      alreadyActive: 'प्रचार पहले से सक्रिय — समाप्ति की प्रतीक्षा करें।',
      daysLeft: '{n} दिन शेष',
      followersGained: 'प्रचार के बाद +{n} नए फॉलोअर',
      settingsSectionTitle: 'मेरा प्रोफ़ाइल प्रचारित करें',
      settingsSectionDesc: '7 दिनों तक वॉइस फ़ीड में अपनी प्रोफ़ाइल की दृश्यता बढ़ाएँ।',
      activePromoLabel: 'सक्रिय प्रचार', noActivePromo: 'कोई सक्रिय प्रचार नहीं',
      startPromo: 'प्रचार शुरू करें (€10 / 7 दिन)',
      history: 'इतिहास', close: 'बंद करें', cancel: 'रद्द करें',
      promoLabel: 'प्रचारित प्रोफ़ाइल',
      followBtn: 'फ़ॉलो', followingBtn: 'फ़ॉलो कर रहे हैं',
      posts: 'पोस्ट', likes: 'लाइक', views: 'व्यू', plays: 'प्ले', followers: 'फ़ॉलोअर', following: 'फ़ॉलोइंग',
      successToast: '{date} तक प्रचार सक्रिय 🎉',
      confirmPay: '7 दिनों के लिए €10 चुकाएँ?',
    },
    story: {
      shareGimToStory: 'स्टोरी में साझा करें', sharePodcastToStory: 'पॉडकास्ट स्टोरी में साझा करें',
      shared: 'स्टोरी में साझा किया गया!', shareError: 'साझा करने में त्रुटि',
      viewGimToli: 'फ़ीड में देखें', viewPodcast: 'फ़ीड में देखें',
      gimShared: 'Gim Toli', podcastShared: 'पॉडकास्ट',
    },
    feed: {
      share: 'साझा करें', shareToStory: 'स्टोरी में साझा करें', shareWithSponsor: 'प्रायोजक के साथ साझा करें', cancel: 'रद्द करें',
      save: 'सहेजें', unsave: 'सहेजे गए से हटाएँ', report: 'रिपोर्ट', moreOptions: 'अधिक विकल्प',
      translateVoice: 'इस वॉइस का अनुवाद करें', translating: 'अनुवाद हो रहा है…',
      playingNow: 'चल रहा है…', replyWithGim: 'Gim Toli से जवाब',
    },
    categories: { catCinema: 'सिनेमा', catSeries: 'सीरीज़', catMaking: 'मेकिंग-ऑफ', catTech: 'तकनीक', catMusic: 'फ़िल्म संगीत', catInterviews: 'इंटरव्यू', catReviews: 'समीक्षा' },
    comments: { title: 'टिप्पणियाँ', addPh: 'टिप्पणी जोड़ें…', beFirst: 'कोई टिप्पणी नहीं — पहले टिप्पणी करें!' },
  },
  // ---------- Dutch ----------
  nl: {
    promote: {
      buttonTitle: 'Mijn profiel promoten', modalTitle: 'Mijn profiel promoten',
      modalSubtitle: 'Boost je profiel 7 dagen in de voice-feed',
      price: '€10', duration: '7 dagen',
      howItWorksTitle: 'Hoe werkt het',
      howItWorks1: 'Je profiel (foto, naam, beschrijving, audio) verschijnt willekeurig in de feed.',
      howItWorks2: 'Verspreiding gedurende 7 dagen.',
      howItWorks3: 'Volg nieuwe volgers via Instellingen › Profiel promoten.',
      payBtn: '€10 betalen en starten', paying: 'Doorverwijzen naar Stripe…',
      alreadyActive: 'Er is al een actieve promotie.',
      daysLeft: 'Nog {n} dag(en)',
      followersGained: '+{n} nieuwe volgers sinds promotie',
      settingsSectionTitle: 'Mijn profiel promoten',
      settingsSectionDesc: 'Verhoog je zichtbaarheid 7 dagen in de voice-feed.',
      activePromoLabel: 'Actieve promotie', noActivePromo: 'Geen actieve promotie',
      startPromo: 'Start promotie (€10 / 7 dagen)',
      history: 'Geschiedenis', close: 'Sluiten', cancel: 'Annuleren',
      promoLabel: 'Uitgelicht profiel',
      followBtn: 'Volgen', followingBtn: 'Volgend',
      posts: 'Berichten', likes: 'Likes', views: 'Weergaven', plays: 'Afspelingen', followers: 'Volgers', following: 'Volgend',
      successToast: 'Promotie actief tot {date} 🎉',
      confirmPay: '€10 betalen voor 7 dagen promotie?',
    },
    story: {
      shareGimToStory: 'Delen in story', sharePodcastToStory: 'Podcast delen in story',
      shared: 'Gedeeld in story!', shareError: 'Deelfout',
      viewGimToli: 'Bekijk in feed', viewPodcast: 'Bekijk in feed',
      gimShared: 'Gim Toli', podcastShared: 'Podcast',
    },
    feed: {
      share: 'Delen', shareToStory: 'Delen in story', shareWithSponsor: 'Delen met sponsor', cancel: 'Annuleren',
      save: 'Opslaan', unsave: 'Uit opgeslagen verwijderen', report: 'Melden', moreOptions: 'Meer opties',
      translateVoice: 'Deze stem vertalen', translating: 'Vertalen…',
      playingNow: 'Wordt afgespeeld…', replyWithGim: 'Reageren met Gim Toli',
    },
    categories: { catCinema: 'Bioscoop', catSeries: 'Series', catMaking: 'Making-of', catTech: 'Tech', catMusic: 'Filmmuziek', catInterviews: 'Interviews', catReviews: 'Recensies' },
    comments: { title: 'Reacties', addPh: 'Reactie toevoegen…', beFirst: 'Nog geen reacties — wees de eerste!' },
  },
  // ---------- Swahili ----------
  sw: {
    promote: {
      buttonTitle: 'Tangaza wasifu wangu', modalTitle: 'Tangaza wasifu wangu',
      modalSubtitle: 'Ongeza mwonekano wa wasifu kwenye mtiririko wa sauti kwa siku 7',
      price: '€10', duration: 'siku 7',
      howItWorksTitle: 'Inavyofanya kazi',
      howItWorks1: 'Wasifu wako (picha, jina, maelezo, sauti) unaonekana kwa nasibu kwenye mtiririko.',
      howItWorks2: 'Utangazwaji kwa siku 7 kwa watumiaji bahati nasibu.',
      howItWorks3: 'Fuatilia wafuasi wapya kupitia Mipangilio › Tangaza wasifu.',
      payBtn: 'Lipa €10 na anza', paying: 'Inaelekeza kwenye Stripe…',
      alreadyActive: 'Tayari kuna utangazaji unaoendelea.',
      daysLeft: 'Siku {n} zimebaki',
      followersGained: '+{n} wafuasi wapya tangu utangazaji',
      settingsSectionTitle: 'Tangaza wasifu wangu',
      settingsSectionDesc: 'Ongeza mwonekano kwa siku 7 kwenye mtiririko.',
      activePromoLabel: 'Utangazaji unaoendelea', noActivePromo: 'Hakuna utangazaji',
      startPromo: 'Anzisha utangazaji (€10 / siku 7)',
      history: 'Historia', close: 'Funga', cancel: 'Ghairi',
      promoLabel: 'Wasifu uliotangazwa',
      followBtn: 'Fuata', followingBtn: 'Unamfuata',
      posts: 'Machapisho', likes: 'Kupenda', views: 'Mionekano', plays: 'Kuchezwa', followers: 'Wafuasi', following: 'Anayefuatwa',
      successToast: 'Utangazaji unaendelea hadi {date} 🎉',
      confirmPay: 'Lipa €10 kwa siku 7 za utangazaji?',
    },
    story: {
      shareGimToStory: 'Shiriki kwenye hadithi', sharePodcastToStory: 'Shiriki podcast kwenye hadithi',
      shared: 'Imeshirikiwa!', shareError: 'Hitilafu ya kushiriki',
      viewGimToli: 'Angalia kwenye mtiririko', viewPodcast: 'Angalia kwenye mtiririko',
      gimShared: 'Gim Toli', podcastShared: 'Podcast',
    },
    feed: {
      share: 'Shiriki', shareToStory: 'Shiriki kwenye hadithi', shareWithSponsor: 'Shiriki na mfadhili', cancel: 'Ghairi',
      save: 'Hifadhi', unsave: 'Ondoa kutoka kwenye zilizohifadhiwa', report: 'Ripoti', moreOptions: 'Chaguo zaidi',
      translateVoice: 'Tafsiri sauti hii', translating: 'Inatafsiri…',
      playingNow: 'Inachezwa sasa…', replyWithGim: 'Jibu kwa Gim Toli',
    },
    categories: { catCinema: 'Sinema', catSeries: 'Mfululizo', catMaking: 'Kutengeneza', catTech: 'Teknolojia', catMusic: 'Muziki wa filamu', catInterviews: 'Mahojiano', catReviews: 'Uhakiki' },
    comments: { title: 'Maoni', addPh: 'Ongeza maoni…', beFirst: 'Hakuna maoni — kuwa wa kwanza!' },
  },
  // ---------- Haitian Creole ----------
  ht: {
    promote: {
      buttonTitle: 'Fè piblisite pou pwofil mwen', modalTitle: 'Fè piblisite pou pwofil mwen',
      modalSubtitle: 'Ranfòse pwofil ou nan fil vwa a pou 7 jou',
      price: '10€', duration: '7 jou',
      howItWorksTitle: 'Kijan sa mache',
      howItWorks1: 'Pwofil ou (foto, non, deskripsyon, odyo) parèt owaza nan fil vwa a.',
      howItWorks2: 'Difize pandan 7 jou pou itilizatè owaza.',
      howItWorks3: 'Swiv nouvo abòne yo nan Paramèt › Fè piblisite pou pwofil mwen.',
      payBtn: 'Peye 10€ epi kòmanse', paying: 'K ap redirije vè Stripe…',
      alreadyActive: 'Gen yon piblisite aktif deja — tann fen an.',
      daysLeft: 'Gen {n} jou ki rete',
      followersGained: '+{n} nouvo abòne depi piblisite a',
      settingsSectionTitle: 'Fè piblisite pou pwofil mwen',
      settingsSectionDesc: 'Ranfòse vizibilite pwofil ou pou 7 jou.',
      activePromoLabel: 'Piblisite aktif', noActivePromo: 'Pa gen piblisite aktif',
      startPromo: 'Kòmanse yon piblisite (10€ / 7 jou)',
      history: 'Istwa', close: 'Fèmen', cancel: 'Anile',
      promoLabel: 'Pwofil pwomouvwe',
      followBtn: 'Swiv', followingBtn: 'W ap swiv',
      posts: 'Piblikasyon', likes: 'Renmen', views: 'Vizyon', plays: 'Ekout', followers: 'Abòne', following: 'W ap swiv',
      successToast: 'Piblisite aktif jiska {date} 🎉',
      confirmPay: 'Peye 10€ pou 7 jou piblisite?',
    },
    story: {
      shareGimToStory: 'Pataje nan istwa', sharePodcastToStory: 'Pataje podcast nan istwa',
      shared: 'Pataje nan istwa!', shareError: 'Erè pandan pataj',
      viewGimToli: 'Wè nan fil la', viewPodcast: 'Wè nan fil la',
      gimShared: 'Gim Toli', podcastShared: 'Podcast',
    },
    feed: {
      share: 'Pataje', shareToStory: 'Pataje nan istwa', shareWithSponsor: 'Pataje ak yon patwone', cancel: 'Anile',
      save: 'Anrejistre', unsave: 'Retire nan anrejistreman', report: 'Rapòte', moreOptions: 'Plis opsyon',
      translateVoice: 'Tradui vwa sa a', translating: 'K ap tradui…',
      playingNow: 'K ap jwe…', replyWithGim: 'Reponn ak yon Gim Toli',
    },
    categories: { catCinema: 'Sinema', catSeries: 'Seri', catMaking: 'Making-of', catTech: 'Tech', catMusic: 'Mizik fim', catInterviews: 'Entèvyou', catReviews: 'Kritik' },
    comments: { title: 'Kòmantè', addPh: 'Ajoute yon kòmantè…', beFirst: 'Pa gen kòmantè — se ou premye a!' },
  },
};

export const usePT = () => {
  const { language } = useLanguage();
  return (key, vars) => {
    const parts = key.split('.');
    let v = D[language] || D.en;
    for (const p of parts) v = v?.[p];
    if (v == null) {
      v = D.en;
      for (const p of parts) v = v?.[p];
    }
    if (typeof v !== 'string') return key;
    if (vars) {
      return v.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : `{${k}}`));
    }
    return v;
  };
};

export default D;
